import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getContractCancellationExpenses, getPropertyTypesFromRoot } from 'modules/settings/api';

export const useQueryContractCancellationExpenses = () => {
  //getContractCancellationExpenses
  const {
    data: allContractPayment,
    isError: errContractCancellationExpenses,
    isLoading: isLoadingContractCancellationExpenses,
  } = useQuery(QUERY_KEYS.CONTRACT_PAYMENT_CANCELLATION_EXPENSES, getContractCancellationExpenses);

  const {
    data: propertyTypesOptions,
    isError: errPropertyTypesOptions,
    isLoading: isLoadingPropertyTypesOptions,
  } = useQuery(QUERY_KEYS.PROPERTY_TYPES, getPropertyTypesFromRoot);

  return {
    contractCancellationExpensesData: allContractPayment?.data || {},
    propertyTypesOptions: propertyTypesOptions?.data || {},
    isError: errContractCancellationExpenses || errPropertyTypesOptions,
    isLoading: isLoadingPropertyTypesOptions || isLoadingContractCancellationExpenses,
  };
};
